// extracted by mini-css-extract-plugin
module.exports = {"scan":"Home_scan__2u6Zt","text":"Home_text__CwI2F","history":"Home_history__3OCEY"};